import { render } from "./ClearButton.vue?vue&type=template&id=21960108&scoped=true&ts=true"
import script from "./ClearButton.vue?vue&type=script&lang=ts"
export * from "./ClearButton.vue?vue&type=script&lang=ts"

import "./ClearButton.vue?vue&type=style&index=0&id=21960108&lang=scss&scoped=true"

import exportComponent from "C:\\www\\Marta\\redadom.pl\\apartment-table\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21960108"]])

export default __exports__